// The correction RPC commits these jobs with the new access date. The browser
// starts them immediately; the regular worker handles unfinished jobs later.
export async function runCancellationBillingChecks(db:any,jobIds:string[],runJob:(id:string)=>Promise<void>) {
  for(const id of jobIds) {
    const current=await db.from('billing_jobs').select('status,last_error').eq('id',id).single();
    if(current.error)throw current.error;
    if(current.data.status==='succeeded')continue;
    if(current.data.status==='failed') {
      const retry=await db.rpc('admin_retry_subscription_action',{p_job_id:id});
      if(retry.error)throw retry.error;
    }
    await runJob(id);
    const result=await db.from('billing_jobs').select('status,last_error').eq('id',id).single();
    if(result.error)throw result.error;
    if(result.data.status!=='succeeded')throw new Error(result.data.last_error || 'De automatische factuurcontrole wordt nog verwerkt. De voortgang staat bij het abonnement.');
  }
}
